export enum IdDocType {
    PASSPORT = "passport",
    ID_CARD = "idCard"
}